import React from 'react'
import styled from 'styled-components'

import { labelDesignItemValues } from '../../../lib/cart/item'
import { CartItemVirtualProduct } from '../../../lib/cart/state/types'

interface LabelInformationProps {
  labelItem: CartItemVirtualProduct
  className?: string
}

const LabelInfoTitle = styled.p`
  font-weight: 500;
  margin-bottom: 0;
`

export const LabelInfoDetails = styled.span`
  background-color: ${({ theme }) => theme.colors.coolGray.cool150};
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  font-size: 12px;
  padding: 10px;
`

const LabelField = styled.span`
  flex-direction: row;
`

const LabelFieldTitle = styled.span`
  font-weight: 500;
`

// TODO: consider replacing this with Label Information component in www/src/components/global/cart/LabelInformation.tsx
const LabelInformation: React.FC<LabelInformationProps> = ({ labelItem, className }) => {
  const labelFeeValues = labelDesignItemValues(labelItem)
  return (
    <div className={className}>
      <LabelInfoTitle>LABEL REQUEST DETAILS</LabelInfoTitle>
      <LabelInfoDetails>
        {labelFeeValues.map(({ label, value }) => (
          <LabelField key={label}>
            <LabelFieldTitle>{label}: </LabelFieldTitle>
            <span>{value}</span>
          </LabelField>
        ))}
      </LabelInfoDetails>
    </div>
  )
}

const StyledLabelInformation = styled(LabelInformation)({
  display: 'flex',
  flexDirection: 'column',
})

export default StyledLabelInformation
